import moment from "moment/moment";

import { Icon, Popup } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

export default function TodoIcon({ todo }) {
	const { t } = useTranslation();

	const { resolved } = todo;

	if (!resolved.status) {
		return null;
	}

	let content = `${t("resolved", "Resolved")} ${moment(resolved.timestamp?.toDate()).fromNow()}`;

	if (resolved.user) {
		content += ` ${t("by", "by").toLowerCase()} ${resolved.user.name}`;
	}

	return (
		<Popup
			position="right center"
			size="tiny"
			content={content}
			trigger={
				<Icon
					fitted
					name="check circle"
					color="green"
					style={{
						fontSize: 18,
					}}
				/>
			}
		/>
	);
}
